import Vue from 'vue';
import Component from 'vue-class-component';
import EdResetPasswordComponent from '@/auth/components/ed-reset-password/ed-reset-password.component.vue'

@Component({
  name: 'reset-password',
  components: {
    EdResetPassword: EdResetPasswordComponent
  },
})
export default class ResetPassword extends Vue {
  
}